import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import { userTypes } from '../../util/userTypes';

import css from './UserNav.module.css';

const getSettingsTabs = currentPage => {
  return [
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];
};

const getClientTabs = currentPage => {
  return [
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];
};

const getBrandAndStoreTabs = (
  currentPage,
  approvedBrandProfile,
  approvedStoreProfile,
  notificationCount
) => {
  return [
    // {
    //   text: <FormattedMessage id="UserNav.addProduct" />,
    //   selected: currentPage === 'NewProductPage',
    //   disabled: !approvedBrandProfile,
    //   linkProps: {
    //     name: 'NewProductPage',
    //   },
    // },
    {
      text: <FormattedMessage id="UserNav.brandsAndProducts" />,
      selected: currentPage === 'ManageListingsPage:my-brand',
      linkProps: {
        name: 'ManageBrandsAndProductsListingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.shopsAndDisplays" />,
      selected: currentPage === 'ManageListingsPage:my-shop',
      linkProps: {
        name: 'ManageShopsAndDisplaysListingsPage',
      },
    },
    // {
    //   text: <FormattedMessage id="UserNav.salesHub" />,
    //   selected: false,
    //   disabled: true,
    //   linkProps: {
    //     name: 'LandingPage',
    //   },
    // },
    {
      text: <FormattedMessage id="UserNav.inbox" />,
      selected: currentPage === 'InboxPage',
      linkProps: {
        name: 'InboxPage',
        params: {
          tab: 'my-shop',
        },
      },
      notificationCount: notificationCount,
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
    // {
    //   text: <FormattedMessage id="UserNav.addDisplay" />,
    //   selected: currentPage === 'NewRentalSpacePage',
    //   disabled: !approvedStoreProfile,
    //   linkProps: {
    //     name: 'NewRentalSpacePage',
    //   },
    // },
  ];
};

const UserNavComponent = props => {
  const {
    className,
    rootClassName,
    currentPage,
    userType,
    approvedBrandProfile = true,
    approvedStoreProfile = true,
    notificationCount = 0,
    locale
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const tabs =
    userType === userTypes.shopper
      ? getClientTabs(currentPage)
      : userType === userTypes.shopsAndBrands || userType === userTypes.shopsAndBrandsAndShopper
      ? getBrandAndStoreTabs(
          currentPage,
          approvedBrandProfile,
          approvedStoreProfile,
          notificationCount
        )
      : getSettingsTabs(currentPage);

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={classNames(css.tab, {[css.deLocaleTab]: locale === 'de' })} tabs={tabs} skin="dark" />
  );
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const {
    currentUserNotificationCount: notificationCount,
    currentUserAsCustomerNotificationCount: notificationCountAsCustomer,

  } = state.user;

  return {
    notificationCount: notificationCount || notificationCountAsCustomer,
  };
};

const UserNav = compose(connect(mapStateToProps))(UserNavComponent);

UserNav.defaultProps = {
  className: null,
  rootClassName: null,
};

const { string } = PropTypes;

UserNav.propTypes = {
  className: string,
  rootClassName: string,
  currentPage: string.isRequired,
};
export default UserNav;
